import { Fragment, lazy, Suspense } from 'react'

import type { ModalComponent } from '@core/modal/types'

const EndConversationConfirmModal = lazy(
  () => import('./EndConversationConfirmModal'),
)

/**
 * Lazy loaded version of SettingsModal.
 * Will only be rendered for non mobile web users.
 */
export const EndConversationConfirmModalLazy: ModalComponent = (props) => {
  return (
    <Suspense fallback={<Fragment />}>
      <EndConversationConfirmModal {...props} />
    </Suspense>
  )
}
